import { render, staticRenderFns } from "./ReportMaintenance.vue?vue&type=template&id=87cfe50c&"
import script from "./ReportMaintenance.vue?vue&type=script&lang=ts&"
export * from "./ReportMaintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87cfe50c')) {
      api.createRecord('87cfe50c', component.options)
    } else {
      api.reload('87cfe50c', component.options)
    }
    module.hot.accept("./ReportMaintenance.vue?vue&type=template&id=87cfe50c&", function () {
      api.rerender('87cfe50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/reports/ReportMaintenance.vue"
export default component.exports